// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__ofeFi","primary":"Button_primary__dQH6j","secondary":"Button_secondary__zC+XT","ghost":"Button_ghost__d0x+e","fullWidth":"Button_fullWidth__XMuXL"};